export const fields: Record<string, string[]> = {
  profile: [],
  finance: ['order-finance'],
  logistic: ['order-logistic'],
  all: ['order-finance', 'order-logistic'],
  sale: ['order-finance', 'order-logistic'],
  credit: ['order-finance', 'order-logistic'],
}
